import List from '@researchgate/react-intersection-list';
import React, { Component } from 'react';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { setPage } from '../../actions/navigation';
import { intersectionTriggered } from '../../actions/uiActions';
import { getCurrentPageNumber } from '../../reducers/page';
import { getIsFetchingPatterns } from '../../reducers/patterns';
import {
    getActiveSewpat, getSewpatGalleryOverlay,
} from '../../reducers/sewpats';
import {
    getContainerPaginationLimit, getPaginationPageCount, showPagination,
} from '../../reducers/ui.pagination';

import {
    getAppBarType,
    getGalleryThumbnailType,
    getPatternsCountToRender,
    showLoader,
} from '../../reducers/ui.patterngallery';
import CategoriesTrail from '../categories/CategoriesTrail';
import MessagePage from '../common/MessagePage';
import SelectedValuesPane from '../common/SelectedValuesPane';
import Text from '../common/Text';
import Heading from '../heading/Heading';
import LinearProgress from '../LinearProgress';
import Pagination from './Pagination';
import PatternCard from './PatternCard';
import PatternGalleryAppBar from './PatternGalleryAppBar';
import PatternGalleryItems from './PatternGalleryItems';

defineMessages({
    nosearchresult: {
        id: 'SEARCH_NO_RESULT',
        defaultMessage: 'Sorry, aber wir haben keine passenden Stoffe für Dich gefunden.',
    },
});


class PatternGalleries extends Component {
    state = {
        itemsToRender: this.props.itemsToRender,
        renderList: false,
    };

    componentDidMount() {
        require('intersection-observer');
        this.setState(Object.assign({}, this.state, { renderList: true }));
    }

    itemRenderer = (index, key) => {
        const { patternIds,
        thumbnailType,
        figurineOverlay,
        sewpat,
        appBarType,
        favoritesMode,
        patterns,
    }
        = this.props;
        const sewpatId = sewpat.id;
        return (
            <PatternCard
                id={patternIds[index]}
                key={key}
                pattern={patterns[patternIds[index]]}
                thumbnailType={thumbnailType}
                overlay={figurineOverlay}
                overlayPath={`schnittmuster/${sewpatId}`}
                sewpatId={sewpatId}
            >
                <PatternGalleryAppBar
                    patternid={patternIds[index]}
                    type={appBarType}
                    favoritesMode={favoritesMode}
                />
            </PatternCard>
        );
    };

    getHelp = () => {
        if (this.props.helpText) {
            return (
                <p>{this.props.helpText}</p>
            );
        }
        return null;
    };

    handleSetPage = page => {
        this.props.setPage(page);
    };

    handleIntersection = (size, pageSize) => {
        this.props.intersectionTriggered(size, pageSize);
    };

    render() {
        if (this.props.isFetching) {
            return <LinearProgress />;
        }

        if (this.props.numberOfPatterns === 0) {
            return (<MessagePage
                messageId='SEARCH_NO_RESULT'
                title={this.title}
            />);
        }

        if (this.state.renderList) {
            return (
                <React.Fragment>
                    <CategoriesTrail />
                    <SelectedValuesPane sewpatId={this.props.sewpat.id} />
                    <Text>
                        <Text.Heading text={this.props.galleryTitle || null} level={3} center />
                        {this.getHelp()}
                    </Text>
                    <List
                        itemCount={this.props.numberOfPatterns}
                        itemsRenderer={PatternGalleryItems} threshold='25%'
                        pageSize={this.props.itemsToRender || 10}
                        onIntersection={this.handleIntersection}
                        renderItem={this.itemRenderer}
                    />
                    <Text>
                        {showPagination ? <Pagination
                            {...this.props.paginationProps}
                            handleSetPage={this.handleSetPage}
                        /> : null}
                        {this.props.showLoader && !this.props.showPagination ?
                            <LinearProgress /> : null}
                    </Text>

                </React.Fragment>
            );
        }
        return (
            <div>
                LOADING ...
                <LinearProgress />
            </div>
        );
    }

}


const mapDispatchToProps = dispatch => (
    {
        setPage: page => dispatch(setPage(page)),
        intersectionTriggered: (count, pagePerLoad) => dispatch(
            intersectionTriggered(count, pagePerLoad)),
    }
);

const mapStateToProps = (state, ownProps) => {
    const {
        totalHits, patterns, items, title,
    } = ownProps;
    const number = items ? items.length : 0;
    const sewpat = getActiveSewpat(state);
    const figurineOverlay = getSewpatGalleryOverlay(state);
    return {
        patterns,
        patternIds: items,
        sewpat,
        figurineOverlay,
        numberOfPatterns: number,
        isFetching: getIsFetchingPatterns(state),
        itemsToRender: getPatternsCountToRender(state),
        thumbnailType: getGalleryThumbnailType(state),
        appBarType: getAppBarType(state),
        galleryTitle: title,
        showPagination: showPagination(state, totalHits),
        showLoader: showLoader(state, totalHits),
        paginationProps: {
            pageCount: getPaginationPageCount(state, totalHits),
            displayLimit: getContainerPaginationLimit(state),
            currentPage: getCurrentPageNumber(state),
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatternGalleries);



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternGalleries.js